module.exports = __webpack_public_path__ + "img/162.364e66dc.jpg";